/**
 * Nazwy modułów
 *
 * @export
 * @enum {number}
 */
export enum ModuleName {
  assessment = 'assessment',
  decision = 'decision',
  edit = 'edit',
  hidden = 'hidden',
  recruitment = 'recruitment'
}
